import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';

const PolicyList = props => {
    return (
        <List divided relaxed className="policies">
            {props.children}
        </List>
    );
};

PolicyList.propTypes = {
    children: PropTypes.node,
};

export default PolicyList;